import { render, staticRenderFns } from "./PartnerRequestList.vue?vue&type=template&id=5cc38112&"
import script from "./PartnerRequestList.vue?vue&type=script&lang=js&"
export * from "./PartnerRequestList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports